import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';

const override = {
  baseUrl: 'https://pioneer-sec-service.uat.onyxcentersource.com',
  hostname: 'pioneer-sec.uat.onyxcentersource.com'
};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.sec.ts